

// localstorage 存储的 key（存在在本地，key不使用过于直白标记，避免用户根据命名去尝试）
const AccessTokenKey = 'token'
export default {
    /**
      * @function readAccessToken
      * @description 读取本地的 access token
      *
      * @returns {string} 令牌
      */

    readAccessToken() {
        return localStorage.getItem(AccessTokenKey)
    },



    /**
 * @function storeTokens
 * @description 存储 token 到本地
 *
 * @param {string} accessToken 访问令牌
 */
    storeTokens(accessToken) {
        localStorage.setItem(AccessTokenKey, accessToken)
    },
}
